module.exports = __webpack_public_path__ + "img/16.a186dac4.jpg";